import { useMemo } from "react";
import { Plan } from "../types/Plan";
import { useGeminiApiKey } from "./use-gemini-api-key";
import { useGoogleAccessToken } from "./use-google-access-token";
import { useLicenseKey } from "./use-license-key";

export function useLocalAppConfig() {
  const { accessToken, setAccessToken } = useGoogleAccessToken();
  const { geminiApiKey, setGeminiApiKey } = useGeminiApiKey();
  const { licenseKey, setLicenseKey } = useLicenseKey();

  return useMemo(() => {
    const signedIn = !!accessToken;
    const plan = Plan.Pro;

    return {
      accessToken,
      setAccessToken,
      geminiApiKey,
      setGeminiApiKey,
      licenseKey,
      setLicenseKey,
      signedIn,
      plan,
    };
  }, [
    accessToken,
    setAccessToken,
    geminiApiKey,
    setGeminiApiKey,
    licenseKey,
    setLicenseKey,
  ]);
}
